import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WebGalleryPhotoGroupContainer from '../WebGalleryPhotoGroup/WebGalleryPhotoGroupContainer';
import WebGalleryAlbumNullState from '../WebGalleryAlbumNullState';
import WebGalleryPhotoGroupCard from './components/WebGalleryPhotoGroupCard';

const propTypes = {
  loading: PropTypes.bool,
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    is_web_gallery: PropTypes.bool,
    is_private_web_gallery: PropTypes.bool,
    root_album_folder: PropTypes.shape({
      id: PropTypes.string,
      join_code: PropTypes.string,
    }),
    creator: PropTypes.shape({
      slug: PropTypes.string,
    }),
    display_public_photo_attribution: PropTypes.bool.isRequired,
  }),
  photosUngrouped: PropTypes.shape({
    total: PropTypes.number,
    count: PropTypes.number,
    records: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        thumbnail_urls: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
          }),
        ),
        watermarked_urls: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
          }),
        ),
        is_favorite: PropTypes.bool,
      }),
    ),
  }),
  photoGroups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      photos: PropTypes.shape({
        total: PropTypes.number,
      }),
      cover_photos: PropTypes.shape({
        records: PropTypes.array,
      }),
    }),
  ),
  loadMoreUngroupedPhotos: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const WebGalleryAlbum = ({
  loadMoreUngroupedPhotos,
  loading,
  album,
  photosUngrouped,
  photoGroups,
}) => {
  if (loading || !album || !photoGroups) {
    return (
      <div className="d-block text-center mt-6">
        <span className="spinner" />
      </div>
    );
  }

  const isNullState =
    (photosUngrouped?.total ?? 0) === 0 && (photoGroups?.length ?? 0) === 0;

  return (
    <Fragment>
      <div className="px-sm-2 px-md-5 px-0">
        {photoGroups?.length > 0 && (
          <div className="photo-group-container">
            {photoGroups.map(photoGroup => (
              <WebGalleryPhotoGroupCard
                key={photoGroup.id}
                album={album}
                photoGroup={photoGroup}
              />
            ))}
          </div>
        )}

        {isNullState && <WebGalleryAlbumNullState album={album} />}
      </div>

      <WebGalleryPhotoGroupContainer
        album={album}
        photoGroup={{
          id: null,
        }}
        photos={photosUngrouped}
        loadMore={loadMoreUngroupedPhotos}
        renderMeta={false}
      />
    </Fragment>
  );
};

WebGalleryAlbum.propTypes = propTypes;

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export { WebGalleryAlbum as WebGalleryAlbumComponent };
export default connect(mapStateToProps)(WebGalleryAlbum);
